import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { Link as RouterLink } from 'react-router-dom'
import { track } from '@amplitude/analytics-browser'
import UserType from 'src/model/user-types'
import CreditBalanceContent from 'src/components/credit-balance-content'
import MessageBoxContent from 'src/model/message-box'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import { userLimitsGetAction } from 'src/reducers/user-limits/action'
import {
  selectCurrentCredits,
  selectUserLimits,
} from 'src/reducers/user-limits/selector'
import WorkspaceMenu from './workspace-menu'
import styles from './styles'

/**
 * Top bar used next to the side nav: workspace switcher, the trial's days
 * left with Upgrade now (trial plans only), and AI credits.
 */
const AppHeader = ({ classes }) => {
  const dispatch = useDispatch()
  const userLimits = useSelector(selectUserLimits)
  const currentCredits = useSelector(selectCurrentCredits)

  useEffect(() => {
    if (!userLimits) {
      dispatch(userLimitsGetAction())
    }
  }, [dispatch, userLimits])

  const daysLeft = window.CONSTANTS?.TRIAL_DAYS_REMAINING
  const isTrial =
    UserType.isTrialEquivalent(window.CONSTANTS?.USER_ROLE_ID) && daysLeft > 0

  const openCreditModal = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          title: 'Your Account Balance',
          component: <CreditBalanceContent />,
          buttons: [],
          maxWidth: '600px',
        }),
      ),
    )
  }

  return (
    <header className={classes.root}>
      <WorkspaceMenu />
      <div className={classes.right}>
        {isTrial && (
          <>
            <span className={classes.trialText}>
              {daysLeft} {daysLeft === 1 ? 'day' : 'days'} left in trial.
            </span>
            <RouterLink
              to="/pricing"
              className={classes.upgrade}
              onClick={() =>
                track('limit_warning_upgrade', {
                  from: 'dashboard_upgrade_button',
                })
              }
            >
              Upgrade now
            </RouterLink>
            <span className={classes.divider} />
          </>
        )}
        <button
          type="button"
          className={classes.credits}
          onClick={openCreditModal}
        >
          <Icon icon="tabler:coin" className={classes.creditsIcon} />
          {Number(currentCredits).toLocaleString('en-US')} Credits
        </button>
      </div>
    </header>
  )
}

export default withStyles(styles)(AppHeader)
